import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { ProductionComponentInstance, ProductionComponentInstanceStatus } from '@paragon/contract-library';

export interface ProductionComponentInstancesState {
  [instanceGuid: string]: ProductionComponentInstance;
}

const initialState: ProductionComponentInstancesState = {};

const productionComponentInstancesSlice = createSlice({
  name: 'productionComponentInstances',
  initialState,
  reducers: {
    productionComponentInstancesLoaded: (state, action: PayloadAction<readonly ProductionComponentInstance[]>) => {
      for (const productionComponentInstance of action.payload) {
        state[productionComponentInstance.guid] = castDraft(productionComponentInstance);
      }
    },
    statusSet: (
      state,
      action: PayloadAction<{
        productionComponentInstanceGuids: readonly string[];
        status: ProductionComponentInstanceStatus;
      }>,
    ) => {
      const { productionComponentInstanceGuids, status } = action.payload;
      for (const productionComponentInstanceGuid of productionComponentInstanceGuids) {
        state[productionComponentInstanceGuid].status = status;
      }
    },
    productionComponentInstancesDeleted: (state, action: PayloadAction<readonly string[]>) => {
      for (const productionComponentInstanceGuid of action.payload) {
        delete state[productionComponentInstanceGuid];
      }
    },
  },
});

export const { productionComponentInstancesLoaded, statusSet, productionComponentInstancesDeleted } =
  productionComponentInstancesSlice.actions;
export const productionComponentInstances = productionComponentInstancesSlice.reducer;
